import { render, staticRenderFns } from "./poi-slide-ar-experience.vue?vue&type=template&id=11b185e0&"
import script from "./poi-slide-ar-experience.vue?vue&type=script&lang=ts&"
export * from "./poi-slide-ar-experience.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports